<template>
    <div id="navigation">
        <button
            class="button is-primary is-fullwidth"
            v-scroll-to="'#section1'"
        >
            <span class="icon">
                <i class="fas fa-spider"></i>
            </span>
            <span>Recommendation Network</span>
        </button>
        <button
            class="button is-primary is-fullwidth"
            v-scroll-to="'#section2'"
        >
            <span class="icon">
                <i class="fas fa-award"></i>
            </span>
            <span>Top Artists/Tracks</span>
        </button>
        <button
            class="button is-primary is-fullwidth"
            v-scroll-to="'#section3'"
        >
            <span class="icon">
                <i class="fas fa-chart-area"></i>
            </span>
            <span>Taste Metrics</span>
        </button>
        <button
            class="button is-primary is-fullwidth"
            v-scroll-to="'#section6'"
        >
            <span class="icon">
                <i class="fas fa-chart-pie"></i>
            </span>
            <span>Top Genres</span>
        </button>
        <button
            class="button is-primary is-fullwidth"
            v-scroll-to="'#section5'"
        >
            <span class="icon">
                <i class="fas fa-list"></i>
            </span>
            <span>Followed Artists & recents</span>
        </button>
        <button
            class="button is-primary is-fullwidth"
            v-scroll-to="'#section4'"
        >
            <span class="icon">
                <i class="fas fa-list-alt"></i>
            </span>
            <span>Global popular Artists</span>
        </button>
    </div>
</template>

<script>
export default {
    name: "Navigation"
};
</script>

<style scoped>
#navigation {
    position: sticky;
    top: 50%;
    transform: translateY(-50%);
}

#navigation .button:not(:last-child) {
    margin-bottom: 5px;
}

/* Stick to the top on mobile */

@media only screen and (max-width: 768px) {
    #navigation {
        position: initial;
        top: initial;
        transform: initial;
    }
}
</style>
